// SPDX-License-Identifier: AGPL-3.0-or-later

import ndLogoUrl from '@app/media/images/nd-logo.png';
import {msg} from '@lingui/core/macro';
import type React from 'react';

export const APPLICATION_ICON_DESCRIPTOR = msg({
	message: '{productName} application icon',
	comment: 'Accessible label for the application icon.',
});

export const FluxerIconMark = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 512 512"
		role="img"
		data-flx="ui.icons.fluxer-icon.img"
		{...props}
	>
		<image href={ndLogoUrl} width="512" height="512" preserveAspectRatio="xMidYMid meet" />
	</svg>
);
